import { EstimateWizard } from "~/components/site/estimate-wizard";
import { submitProject } from "~/lib/project-submission.server";
import { buildMarketingMeta } from "~/lib/seo/route-meta";
import type { Route } from "./+types/_marketing.estimate";

export const meta: Route.MetaFunction = ({ location }) =>
  buildMarketingMeta({ pathname: location.pathname, keyPrefix: "estimate.page.meta" });

export async function action({ request }: Route.ActionArgs) {
  return submitProject(request);
}

export default function Estimate() {
  return <div className="relative z-10"><EstimateWizard /></div>;
}
